export function glean(source, accessor, defaultValue = null) {
    try {
        const val = accessor(source);
        if (typeof val === 'undefined') { return defaultValue; }
        return val;
    } catch (err) {
        return defaultValue;
    }
}
